import { render, staticRenderFns } from "./PostingV2.vue?vue&type=template&id=ae92c326"
import script from "./PostingV2.vue?vue&type=script&lang=ts"
export * from "./PostingV2.vue?vue&type=script&lang=ts"
import style0 from "./PostingV2.vue?vue&type=style&index=0&id=ae92c326&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae92c326')) {
      api.createRecord('ae92c326', component.options)
    } else {
      api.reload('ae92c326', component.options)
    }
    module.hot.accept("./PostingV2.vue?vue&type=template&id=ae92c326", function () {
      api.rerender('ae92c326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recruiting/PostingV2.vue"
export default component.exports